import { createI18n } from 'vue-i18n';
import pearConfig from './config';
import CustomFormatter from './i18ntransform';
import { getCurrentLocale } from './i18nMap';
import { locales } from './arco';
import { loadPearLocale } from '@/libs/pearConfig';


const formatSupportLangs = ()=> {
  // 通过definePlugin注入
  if (typeof __SUPPORT_LANGS__ === 'undefined') return [];

  return __SUPPORT_LANGS__ ? __SUPPORT_LANGS__ : [];
};

const formatFallbackLangCode = () => {
  if (typeof __FALLBACK_LANG_CODE__ === 'undefined') return '';
  return __FALLBACK_LANG_CODE__;
};

const supportLangs = formatSupportLangs();
const pearFallbackLangCode = formatFallbackLangCode();

const i18n = createI18n({
  // locale: 'en', // 设置当前语言类型
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局注册$t方法
  formatter: new CustomFormatter(),
});

export const arcoLocale = ref();

const loadArcoLocale = async (lang) => {
  const load = locales[lang] || locales.en;
  const locale = await load();
  return locale.default;
};

export const loadLang = async (lang) => {
  // 设置多语言切换，调试可以加上?lang=ar，进行多语言切换
  let curLang = getCurrentLocale(lang || localStorage.getItem('lang') || navigator.language);
  const isCurLocaleSupported = supportLangs.includes(curLang);
  curLang = isCurLocaleSupported ? curLang : pearFallbackLangCode;

  const [pearMessages, arcoMessages, typeMessages] = await Promise.all([
    loadPearLocale(pearConfig.PEAR_ID, curLang),
    loadArcoLocale(curLang),
    loadPearLocale(pearConfig.TYPE_PEAR_ID, curLang),
  ]);

  arcoLocale.value = arcoMessages;
  i18n.global.locale.value = curLang;
  i18n.global.setLocaleMessage(curLang, Object.assign({}, pearMessages, typeMessages));
  document.querySelector('html').setAttribute('lang', curLang);
};

export default i18n;
